'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var slideSpeed = '400';

	var recruitInfoCurrent = function recruitInfoCurrent() {
		$('.recruit-info-nav-body').find('a').each(function (idx, val) {
			if ($(val).attr('href') === FUNCTIONS.va.pathname) {
				$(val).addClass('is-current');
			}
		});
	};
	var recruitInfoNavSwitch = function recruitInfoNavSwitch() {
		if (FUNCTIONS.va.window.width <= FUNCTIONS.va.device.desktop) {
			console.log('switch');
			$('.recruit-info-nav-head').on('click', function (e) {
				$(e.currentTarget).toggleClass(a);
				$(e.currentTarget).next('.recruit-info-nav-body').slideToggle(slideSpeed);
			});
		}
	};

	if ($('.recruit-info-nav').length) {
		recruitInfoCurrent();
		recruitInfoNavSwitch();
	}
})(window.jQuery, window.FUNCTIONS);